import gql from 'graphql-tag';
import client from './apollo';
import { getSession, logout, updateAccessToken } from '../../src/services/useSession';
import trackedNavigate from '../../src/services/trackedNavigate';

const RefreshTokenMutation = gql`
  mutation RefreshTokenMutation {
    refreshToken {
      accessToken
    }
  }
`;

export async function refreshAccessToken() {
  const { refreshToken } = getSession();

  const response = await client.mutate({
    mutation: RefreshTokenMutation,
    context: {
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    },
  });

  if (response.data?.refreshToken?.accessToken) {
    const accessToken = response.data.refreshToken.accessToken;
    await updateAccessToken(accessToken);
    return accessToken;
  } else {
    await forceLogout();
  }
}

/**
 * Force logout the user and redirect to sign-in using a full-page redirect
 */
export async function forceLogout() {
  await logout(() => {
    trackedNavigate('/sign-in', true);
  });
}
